import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        max-width: ${theme.tggSpacing(rem(68.8), 275)};
        padding: ${theme.tggSpacing(rem(3), 2)};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
	`}
`;
